import { put, takeLatest } from 'redux-saga/effects';


//Action
import { loadingSet } from '../action/uiAction';
//Func
import { cookieDel } from '../func/cookieEdit';

function* logout(action) {
  yield put(loadingSet(true));

  if (action.payload.autoLoginDel) {
		cookieDel('ULPC');
	}

  yield put({
    type: "REDUCER_INIT",
  });

  yield put(loadingSet(false));
  window.location.href = "https://www.partner-s.net/logout/";
}


const saga = [
  takeLatest('LOGOUT', logout),
];

export default saga;
